// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  // API  
  //apiUrl: 'http://localhost:54064/api',
  //apiUrl: 'https://localhost:2132/api',
  apiUrl: 'https://avemovbo.aveiport.pt/api',
  //apiUrl: 'https://tcglavemovbackend.ete.pt/api',
  //apiUrl: 'http://gesqldweb/avemov_backend/api',
  // Paging
  pageSize: 10

};



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/environments/environment.ts